import { ChangeDetectionStrategy, Component, type OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-exit-page-modal',
    templateUrl: './exit-page-modal.component.html',
    styleUrls: ['./exit-page-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class ExitPageModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);

    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public onCloseModal(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
